import {
  POST_LOGIN_REQUEST,
  POST_LOGIN_SUCCESS,
  POST_LOGIN_FAILURE,
  USER_LOADED,
  LOGOUT,
} from "../../../constants/actions-types";

const initialState = {
  tokens: localStorage.getItem("authToken"),
  user: JSON.parse(localStorage.getItem("authToken"))?.user,
  loading: false,
  error: null,
  activities: [],
  notifications: [],
};

export default function auth (state = initialState, action) {
    const { type, payload } = action;
      switch (type) {
        case USER_LOADED:
          return {
            ...state,
            loading: false,
            tokens: payload,  
            user: payload?.user,  
          };
        case POST_LOGIN_SUCCESS:
          return {
            ...state,
            loading: false,
            tokens: payload,  
            user: payload?.user,  
          };
       /*  case GET_ACTIVITIES_SUCCESS:
          return {
            ...state,
            loading: false,
            activities: payload
          }
        case GET_NOTIFICATIONS_SUCCESS:
          return {
            ...state,
            loading: false,
            notifications: payload
          } */
        case POST_LOGIN_REQUEST:
/*         case GET_ACTIVITIES_REQUEST:
        case GET_NOTIFICATIONS_REQUEST:
        case POST_NOTIFICATIONS_REQUEST: */
          return {
            ...state,
            loading: true,
          };
/*         case POST_NOTIFICATIONS_SUCCESS:
          return {
            ...state,
            loading: false,
            notifications: []
          };
         */
        case POST_LOGIN_FAILURE:
/*         case POST_NOTIFICATIONS_FAILURE:
        case GET_ACTIVITIES_FAILURE:
        case GET_NOTIFICATIONS_FAILURE: */
          return {
            ...state,
            loading: false,
            error: payload,
          };
        case LOGOUT:
        default:
          return state;
    }
};